import {PinProtect} from '~/features/Auth/PinProtect';
import {TrialCodes} from '~/features/Premium';

export const TrialCodesScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <TrialCodes />
      </PinProtect>
    </div>
  );
};
